export default __webpack_public_path__ + "static/media/knet.bf71d55c.svg";